import { render, staticRenderFns } from "./carDispatchForm.vue?vue&type=template&id=bb98c592&scoped=true"
import script from "./carDispatchForm.vue?vue&type=script&setup=true&lang=js"
export * from "./carDispatchForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./carDispatchForm.vue?vue&type=style&index=0&id=bb98c592&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb98c592",
  null
  
)

export default component.exports